<template>
  <div>
    <b-modal id="modal-input-kas-virtual" title="Input Kas Virtual" no-close-on-backdrop>
      <div>
        <b-form-group label="Cabang">
          <multiselect name="cabang" v-model="forms.cabang" :options="optionsCabang" :internal-search="true"
            :allow-empty="false" deselect-label="" select-label="" label="name" track-by="id"
            placeholder="-- Pilih Cabang --" />

          <b-button v-if="forms.cabang" size="sm" variant="pgiBtn" class="mt-3" @click="onShowModalHistory">
            Lihat Sejarah
          </b-button>
        </b-form-group>

        <b-form-group label="Tipe">
          <b-form-select v-model="forms.type" id="type" name="type" :options="optionsType">
            <template v-slot:first>
              <b-form-select-option :value="null" disabled>-- Pilih Tipe --</b-form-select-option>
            </template>
          </b-form-select>
        </b-form-group>

        <b-form-group label="Nominal">
          <b-input-group prepend="Rp.">
            <b-form-input v-model="forms.amount" placeholder="Masukkan Nominal" required></b-form-input>
          </b-input-group>
        </b-form-group>

        <b-form-group label="Keterangan" class="mb-0">
          <b-form-textarea v-model="forms.notes" name="keterangan" rows="3" max-rows="6"
            maxlength="100"></b-form-textarea>
        </b-form-group>
      </div>

      <template v-slot:modal-footer="{ cancel }">
        <b-button variant="secondary" name="closeEditBtn" @click="cancel()">
          Cancel
        </b-button>
        <b-button variant="primary" name="submitEditBtn" @click="onConfirm()">
          Submit
        </b-button>
      </template>
    </b-modal>

    <ModalHistoryKasVirtual :stateHistory="stateHistory" :pagination="stateHistory.pagination"
      :stateTotalBalanceCabang="stateTotalBalanceCabang" :cabang="forms.cabang" @retry="onRetry"
      @onLimitChange="onLimitChange" @onPageChange="onPageChange" />
    <ModalConfirm id="modal-confirm-input-kas-virtual" title="Confirm Input Kas Virtual" :isSubmitting="isLoadingSubmit"
      desc="Apakah anda yakin untuk input kas virtual ini ?" @submit="onSubmitForm()" />
  </div>
</template>

<script>
import ModalHistoryKasVirtual from './ModalHistoryKasVirtual.vue';
import CONSTANTS from '@/constants'

export default {
  name: "ModalInputKasVirtual",
  components: {
    ModalHistoryKasVirtual,
  },
  props: {
    optionsCabang: {
      type: Array,
      required: true,
    }
  },
  data() {
    return {
      forms: {
        cabang: null,
        type: null,
        amount: '',
        notes: '',
      },
      isLoadingSubmit: false,
      optionsType: [
        {
          value: 'penambahan',
          text: 'Penambahan'
        },
        {
          value: 'pengurangan',
          text: 'Pengurangan'
        },
      ],
      stateHistory: {
        data: [],
        pagination: {
          currentPage: 1,
          show: 10,
          perPage: 10,
          totalRows: 0,
          totalPages: 0,
          totalViewText: "",
          optionsLimit: CONSTANTS.OPTIONS_LIMIT_PAGINATION,
        },
        isLoading: false,
        isError: false,
      },
      stateTotalBalanceCabang: {
        data: null,
        isLoading: false,
        isError: false,
      }
    };
  },
  methods: {
    onConfirm() {
      if (!this.validationSubmitForm()) return
      this.$bvModal.show("modal-confirm-input-kas-virtual")
    },
    onSubmitForm() {
      const formatAmount = this.$helper.removeThousandSeparator(this.forms.amount)

      const amount = this.forms.type === 'pengurangan'
        ? -Math.abs(formatAmount)
        : Math.abs(formatAmount)

      const payload = {
        cabangId: this.forms.cabang.id,
        amount,
        notes: this.forms.notes,
      }

      this.isLoadingSubmit = true;
      this.$axios.post('virtual-balance/finance-adjust', {}, { params: payload }).then(response => {
        this.$helper.toastSucc(this, response.data.name)
        this.$bvModal.hide("modal-confirm-input-kas-virtual")
        this.$bvModal.hide("modal-input-kas-virtual")
        this.forms = {
          cabang: null,
          type: null,
          amount: '',
          notes: '',
        }
        this.$emit('onSuccessInputKasVirtual')
      }).catch(error => {
        this.$helper.parseError(this, error)
      }).finally(() => {
        this.isLoadingSubmit = false;
      })
    },
    onShowModalHistory() {
      this.$bvModal.show("modal-history-kas-virtual")
      this.getHistoryKasVirtual()
      this.getTotalBalanceCabang()
    },
    validationSubmitForm() {
      if (this.$helper.isNullOrEmpty(this.forms.cabang)) {
        this.$helper.toastErr(this, "Mohon memilih cabang terlebih dahulu!")
        return false
      }

      if (this.$helper.isNullOrEmpty(this.forms.type)) {
        this.$helper.toastErr(this, "Mohon memilih tipe terlebih dahulu!")
        return false
      }

      const formatAmount = this.$helper.removeThousandSeparator(this.forms.amount)

      if (this.$helper.isNullOrEmpty(formatAmount)) {
        this.$helper.toastErr(this, "Mohon masukan nominal terlebih dahulu!")
        return false
      }

      if (this.$helper.isNullOrEmpty(this.forms.notes)) {
        this.$helper.toastErr(this, "Mohon masukan keterangan terlebih dahulu!")
        return false
      }

      return true;
    },
    getHistoryKasVirtual(page) {
      this.stateHistory.data = [];
      this.stateHistory.isLoading = true;
      this.stateHistory.isError = false;
      this.stateHistory.pagination.currentPage = isNaN(page) ? 1 : page;

      const params = {
        cabangId: this.forms.cabang.id,
        page: this.stateHistory.pagination.currentPage - 1,
        size: this.stateHistory.pagination.perPage,
      }

      this.$axios.get('virtual-balance/finance-get-balance', { params }).then(response => {
        this.stateHistory.data = response.data.content;
        this.stateHistory.pagination.totalRows = response.data.totalElements

        let pg = this.stateHistory.pagination.currentPage - 1

        let prev = pg * this.stateHistory.pagination.show + 1
        let limit = pg * this.stateHistory.pagination.show + this.stateHistory.pagination.show
        if (limit > this.stateHistory.pagination.totalRows) limit = this.stateHistory.pagination.totalRows

        this.stateHistory.pagination.totalViewText = "Menampilkan " + prev + " - " + limit + " dari " + this.stateHistory.pagination.totalRows + " entri"
      }).catch(error => {
        this.$helper.parseError(this, error)
        this.stateHistory.isError = true;
      }).finally(() => {
        this.stateHistory.isLoading = false;
      })
    },
    getTotalBalanceCabang() {
      this.stateTotalBalanceCabang.data = null;
      this.stateTotalBalanceCabang.isLoading = true;
      this.stateTotalBalanceCabang.isError = false;
      const cabangId = this.forms.cabang.id
      this.$axios.get(`cabang/balance/${cabangId}`).then(response => {
        this.stateTotalBalanceCabang.data = response.data;
      }).catch(error => {
        this.$helper.parseError(this, error)
        this.stateTotalBalanceCabang.isError = true;
      }).finally(() => {
        this.stateTotalBalanceCabang.isLoading = false;
      })
    },
    onLimitChange(newPerPage) {
      this.stateHistory.pagination.perPage = newPerPage
      this.getHistoryKasVirtual()
    },
    onPageChange(newPage) {
      this.getHistoryKasVirtual(newPage)
    },
    onRetry() {
      this.getHistoryKasVirtual()
      this.getTotalBalanceCabang()
    }
  },
  watch: {
    "forms.amount": function (newValue) {
      let cleanValue = this.$helper.changeToValue(newValue);
      const result = cleanValue.replace(/(?!^-)[^0-9]/g, "")
        .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      this.$nextTick(() => this.forms.amount = result);
    },
  },
};
</script>